import { render, staticRenderFns } from "./TransactionCustomer.vue?vue&type=template&id=fc067958"
import script from "./TransactionCustomer.vue?vue&type=script&lang=js"
export * from "./TransactionCustomer.vue?vue&type=script&lang=js"
import style0 from "./TransactionCustomer.vue?vue&type=style&index=0&id=fc067958&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports